/* eslint-disable linebreak-style */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import fixCharsString from 'root/utils/fixCharsString';
import { Sentry } from 'root/utils/raven';

const getConfig = require('next/config').default;

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const SEO = ({ resource: { metas, published, modified, title, options } }) => {
  Sentry.addBreadcrumb({
    category: 'components/seo',
    message: 'Init SEO metas',
    level: Sentry.Severity.Debug,
  });
  return (
    <Head>
      <meta charSet="utf-8" />
      <link
        rel="icon"
        type="image/png"
        href={`/images/themes/${publicRuntimeConfig.APP_THEME}/favicon/icon-72x72.png`}
      />
      <meta name="theme-color" content={`${publicRuntimeConfig.themeColor}`} />
      {metas && metas.title && <title>{fixCharsString(metas.title)}</title>}
      {metas && metas.canonical && <link rel="canonical" href={metas.canonical} />}
      {metas && metas.ampUrl && <link rel="amphtml" href={metas.ampUrl} />}
      {metas && metas.description && <meta name="description" content={fixCharsString(metas.description)} />}
      {metas && metas.robots && <meta key="robots" name="robots" content={metas.robots} />}
      {metas && metas['article:publisher'] && <meta property="article:publisher" content={metas['article:publisher']} />}
      {metas && metas['article:tag'] && metas['article:tag'].map((tag, idx) => (
        <meta key={`tag-${idx}`} property="article:tag" content={tag.content} />
      ))}
      {metas && metas['article:section'] && <meta property="article:section" content={metas['article:section']} />}
      {published && <meta property="article:published_time" content={published} />}
      {modified && <meta property="article:modified_time" content={modified} />}
      {/* Open Graph metas */}
      {metas && metas['og:locale'] && <meta property="og:locale" content={metas['og:locale']} />}
      {metas && metas['og:type'] && <meta property="og:type" content={metas['og:type']} />}
      {metas && metas['og:title'] && <meta property="og:title" content={fixCharsString(metas['og:title'])} />}
      {metas && metas['og:description'] && <meta property="og:description" content={fixCharsString(metas['og:description'])} />}
      {metas && metas.canonical && <meta property="og:url" content={metas.canonical} />}
      {metas && metas['og:site_name'] && <meta property="og:site_name" content={metas['og:site_name']} />}
      {modified && <meta property="og:updated_time" content={modified} />}
      {metas && metas['og:image'] && <meta property="og:image" content={metas['og:image']} />}
      {metas && metas['og:image:alt'] && <meta property="og:image:alt" content={metas['og:image:alt']} />}
      {metas && metas['og:image:width'] && <meta property="og:image:width" content={metas['og:image:width']} />}
      {metas && metas['og:image:height'] && <meta property="og:image:height" content={metas['og:image:height']} />}
      {metas && metas['og:image:secure_url'] && <meta property="og:image:secure_url" content={metas['og:image:secure_url']} />}
      {metas && metas['twitter:card'] && <meta name="twitter:card" content={metas['twitter:card']} />}
      {metas && metas['og:title'] && <meta property="twitter:title" content={fixCharsString(metas['og:title'])} />}
      {metas && metas['og:description'] && <meta property="twitter:description" content={fixCharsString(metas['og:description'])} />}
      {metas && metas['twitter:site'] && <meta name="twitter:site" content={metas['twitter:site']} />}
      {metas && metas['og:image'] && <meta name="twitter:image" content={metas['og:image']} />}
      {metas && metas['twitter:creator'] && <meta name="twitter:creator" content={metas['twitter:creator']} />}
      {metas && metas.schema && <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(metas.schema) }} />}
      {publicRuntimeConfig.fb_app_id && <meta property="fb:app_id" content={publicRuntimeConfig.fb_app_id} /> }
      {publicRuntimeConfig.fb_page_id && <meta property="fb:pages" content={publicRuntimeConfig.fb_page_id} />}
      {options?.taboola_indexable === 'off' && <meta name="taboola-indexable" content="false" />}
    </Head>
  );
};

SEO.defaultProps = {
  resource: {},
};

SEO.propTypes = {
  resource: PropTypes.object,
};

export default SEO;
